import React from "react";

import { Layout } from "../Layout";
import Spinner from "./Spinner";
import AsyncGet from "../../../Materials/AsyncGet";
import InputDisplay from "../../InputDisplay";

export default function Async(props) {
    const {
        prompt = "Please select...",
        input,
        meta,
        allLabel,
        required,
        disabled,
        async = {},
        label = false,
        display = false,
        autoSelect = false,
        selectValue = () => { },
        onChangeHandler = () => { }
    } = props;

    return (
        <AsyncGet
            {...async}
            permissionText={false}
            loadOnMount={true}
            render={({ fetching, data, loaded }) => {
                const { list = [] } = data;
                return (
                    <>
                        {
                            fetching === true && display === false && (
                                <Spinner prompt={prompt} label={label} />
                            )
                        }
                        {
                            fetching === false && (
                                <>
                                    {
                                        display === true && (
                                            <InputDisplay input={{ value: selectValue(list, loaded) }} label={label} />
                                        )
                                    }
                                    {
                                        display === false && (
                                            <Layout
                                                meta={meta}
                                                list={list}
                                                input={input}
                                                label={label}
                                                loaded={loaded}
                                                allLabel={allLabel}
                                                prompt={prompt}
                                                required={required}
                                                disabled={disabled}
                                                autoSelect={autoSelect}
                                                selectValue={selectValue}
                                                onChangeHandler={onChangeHandler}
                                            />
                                        )
                                    }
                                </>
                            )
                        }
                    </>
                )
            }}
        />
    )
}